import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emptyFallback',
  standalone: true,
})
export class EmptyFallbackPipe implements PipeTransform {
  transform<T>(
    value: T | null | undefined,
    fallback: string = '-',
  ): T | string {
    if (
      value === null ||
      value === undefined ||
      (typeof value === 'string' && value.trim() === '')
    ) {
      return fallback;
    }

    return value;
  }
}
